import { memo } from 'react';

import { ImageIcon, ImagesIcon, LayoutGridIcon } from '@air/design-icons';

import { type WorkspaceAgentComposerScopeKind } from '~/components/v2/components/workspace/workspace-agent-panel/utils/buildWorkspaceAgentComposerScopeChip';

export type WorkspaceAgentComposerScopeBarKindIconProps = {
  kind: WorkspaceAgentComposerScopeKind;
};

export const WorkspaceAgentComposerScopeBarKindIcon = memo(({ kind }: WorkspaceAgentComposerScopeBarKindIconProps) => {
  if (kind === 'board') {
    return <LayoutGridIcon aria-hidden className="shrink-0" size="xs" />;
  }

  if (kind === 'asset-stack') {
    return <ImagesIcon aria-hidden className="shrink-0" size="xs" />;
  }

  return <ImageIcon aria-hidden className="shrink-0" size="xs" />;
});

WorkspaceAgentComposerScopeBarKindIcon.displayName = 'WorkspaceAgentComposerScopeBarKindIcon';
